var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AUTH_DATA, REFRESH_TOKEN } from '~constants/cpa-message-codes';
import { refresh } from '~slices/auth';
import store from '~store/configureStore';
import { compareVersions } from '~utils/compareVersions';
import { loadCpaAppVersionFromStorage } from '~utils/localStorage';
var pendingRefresh = null;
export var refreshToken = function () {
    if (pendingRefresh) {
        return pendingRefresh;
    }
    pendingRefresh = (function () { return __awaiter(void 0, void 0, void 0, function () {
        var cpaAppVersion, allowedCpaAppVersion, isCPARefreshTokenAvailable, refreshResponse, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, 5, 6]);
                    cpaAppVersion = loadCpaAppVersionFromStorage();
                    allowedCpaAppVersion = '1.1.79';
                    isCPARefreshTokenAvailable = !!cpaAppVersion &&
                        compareVersions(cpaAppVersion, allowedCpaAppVersion) >= 0;
                    if (!(window.isWebView && isCPARefreshTokenAvailable)) return [3 /*break*/, 2];
                    return [4 /*yield*/, new Promise(function (resolve) {
                            var _a;
                            var settled = false;
                            var authDataListener = function (event) {
                                try {
                                    var parsedData = JSON.parse(event.data);
                                    var code = parsedData === null || parsedData === void 0 ? void 0 : parsedData.code;
                                    var params = parsedData === null || parsedData === void 0 ? void 0 : parsedData.params;
                                    if (code === AUTH_DATA && params) {
                                        settled = true;
                                        clearTimeout(timeoutId);
                                        window.removeEventListener('message', authDataListener, false);
                                        resolve(params);
                                    }
                                }
                                catch (err) {
                                    console.error('Error refreshing token (WebView):', err);
                                    resolve(null);
                                }
                            };
                            window.addEventListener('message', authDataListener, false);
                            (_a = window.ReactNativeWebView) === null || _a === void 0 ? void 0 : _a.postMessage(JSON.stringify({ code: REFRESH_TOKEN }));
                            var timeoutId = window.setTimeout(function () {
                                if (!settled) {
                                    window.removeEventListener('message', authDataListener);
                                    resolve(null);
                                }
                            }, 30000);
                        })];
                case 1: return [2 /*return*/, _a.sent()];
                case 2: return [4 /*yield*/, store.dispatch(refresh())];
                case 3:
                    refreshResponse = (_a.sent()).payload;
                    if (refreshResponse && 'accessToken' in refreshResponse) {
                        return [2 /*return*/, refreshResponse];
                    }
                    else {
                        return [2 /*return*/, null];
                    }
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _a.sent();
                    console.error('Error refreshing token:', error_1);
                    return [2 /*return*/, null];
                case 5:
                    setTimeout(function () {
                        pendingRefresh = null;
                    }, 1500);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); })();
    return pendingRefresh;
};
